import { RouteObject } from 'react-router-dom';
import { PublicBase } from '../components/sections';
import { LandingRoutes } from '../features/landing/routes';
import { AuthRoutes } from '../features/auth';
import { CulturalRoutes } from '../features/cultural-context/routes';
import { NotFoundPage } from '../components/common/NotFoundPage';
import About from '../features/landing/page/About';
import Privacy from '../features/landing/page/Privacy';
import Pricing from '../features/landing/page/Pricing';
import TermsAndConditions from '../features/landing/page/Terms';
import CookiesPolicy from '../features/landing/page/Cookies';
import PublicTreePage from '../features/family-tree/page/PublicTreePage';
import UnsubscribePage from '../features/landing/page/Unsubscribe';

export const publicRoutes: RouteObject[] = [
  {
    path: '/',
    element: <PublicBase />,
    children: [
      {
        index: true,
        element: <LandingRoutes />,
      },
      {
        path: '/sample-tree',
        element: <PublicTreePage />,
      },
      {
        path: 'hub/*',
        element: <CulturalRoutes />,
      },
      {
        path: '/pricing',
        element: <Pricing />,
      },
      {
        path: '/about',
        element: <About />,
      },
      {
        path: '/privacy',
        element: <Privacy />,
      },
      {
        path: '/terms',
        element: <TermsAndConditions />,
      },
      {
        path: '/cookie-policy',
        element: <CookiesPolicy />,
      },
      {
        path: '/unsubscribe',
        element: <UnsubscribePage />,
      },
    ],
  },
  {
    path: '/auth/*',
    element: <AuthRoutes />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];
